"use client";

import React, { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { OrderModal } from "@/components/OrderModal";

interface PageShellProps {
  children: (openOrderModal: (service?: string) => void) => React.ReactNode;
}

export function PageShell({ children }: PageShellProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalService, setModalService] = useState<string | undefined>(undefined);

  const handleOpenModal = (service?: string) => {
    setModalService(service);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalService(undefined);
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FA] text-[#0F172A] dark:bg-[#0B0D14] dark:text-[#F8FAFC] transition-colors duration-200">
      <Header onOpenOrderModal={handleOpenModal} />
      <main className="flex-1 pt-24 sm:pt-28">
        {children(handleOpenModal)}
      </main>
      <Footer />
      <OrderModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        initialService={modalService}
      />
    </div>
  );
}

